

  (function injectPopupCss() {
  const STYLE_ID = "pp-visualizer-styles";
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.type = "text/css";

  const css = String.raw`


 * {
    box-sizing: border-box;
  }

  .popup {
    display: none;
    position: fixed;
    inset: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 1000;
  }

  .popup-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #BABABA;
    width: 600px;
    padding: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin:auto;
    border: 5px solid white;
    border-radius: 17px;
    background-size: cover;
    background-position: center;
    background-blend-mode: overlay;
    background-blend-mode: normal;
    opacity: 1 !important; 
    overflow: hidden;
    transform-origin: center center;
    will-change: transform; 
  }

  #removeWallBtn[data-mode="add"] {
    background-color: darkgreen !important;
    border-color: darkgreen !important;
  }

  #removeWallBtn {
    background-color: #28a745 !important;
    color: white !important;
    border-color: #218838 !important;
  }

  #removeWallBtn.hover-green {
    background-color: green !important;
    color: white !important;
  }

  #removeWallBtn.hover-green:hover {
    background-color: green !important;
    color: white !important;
  }

  .close-btn {
    position: absolute;
    top: -25px;
    right: 15px;
    font-size: 55px;
    cursor: pointer;
    z-index: 521;
    transition: transform 0.25s ease;
    text-shadow: 
    0 0 1px #fff,
    0 0 2px #fff,
    0 0 3px #fff,
    0 0 4px #fff;
  }

  .popup-content .close-btn{
    transition: none !important;    
    -webkit-tap-highlight-color: transparent;
    clip-path: polygon(calc(100% - 55px) 0, 100% 0, 100% 55px, calc(100% - 55px) 55px);
  }
  
  .popup-content .close-btn:hover,
  .popup-content .close-btn:active{
    transform: none !important;      /* hover’daki minik hareketi tamamen kaldır */
  }

  .close-btn:hover {
    /* transform: rotate(90deg); */
	/*transform: scale(1.1);*/
  }

  .close-btn:active {
   /* transform: rotate(-90deg); */
  }
  
  .open-popup-btn {
    /* width: 100%; */
  /*  padding: 15px 0; */
    background-color: #40ad1c;
    color: white;
    /* border: none;  */
    cursor: pointer;
   /* font-size: 16px */;
    text-align: center;
   /* border-radius: 4px !important */;
   /* font-weight: bold !important */;
  }

  .open-popup-btn:hover {
    background-color: #5dbe3d;
  }
  
  .controls-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 15px;
    position: relative;
  }

  .color-pickers {
    display: flex;
    gap: 20px;
    flex-grow: 1;
    justify-content: center;
    margin-top: -15px;
    z-index: 444;
  }

  .color-picker {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .color-picker label {
    margin-right: 10px;
    font-size:22px;
    font-weight: 600;
    text-shadow: 
        -1px 0 0 white,
        1px 0 0 white,
        0 -1px 0 white,
        0 1px 0 white;
  }

  .frame-buttons-wrapper {
    position: absolute;
    right: 0;
    top: 0;
   width: 100%;
    display: flex;
    align-items: flex-start;
    padding-top: 50px;
    z-index: 11; justify-content: center; 
  }

  .frame-buttons {
    display: flex;
    flex-direction: row;
    gap: 8px;
   
  }

  .frame-btn {
    padding: 8px 12px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
     width: 110px;
    text-align: center;
	height:45px !important;
	
  }

  .frame-btn:hover {
    background-color: #e0e0e0;
  }

  .frame-btn.active, 
  .frame-btn.active:hover {
    background-color: #007bff !important;
    color: white !important;
    border-color: #0056b3 !important;
  }

  .frame-container {
    position: relative;
    width: 100%;
  }

  .urun-image {
    max-width: 62%;
    height: auto;
    display: block;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.4)); 
    transition: transform 0.3s ease;
    

  }

  .frame-img {
    position: absolute;
    top: 0;
    left: 50%;
    max-width: 62%;
    height: auto;
    z-index: -2;
    display: none;
    filter: drop-shadow(3px -3px 2px rgba(0, 0, 0, 0.4)) !important;
    transition: transform 0.3s ease;
  }
  
  .chair-container {
    filter: drop-shadow(5px 5px 2px rgba(0, 0, 0, 0.4));
  }

  .chair-img,
  .chair-img-overlay,
  .chair-img-overlay-2 {
    filter: none;
  }
  
  .chair-container {
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 600px;
    margin-top: 20px;
  }

  .chair-img {
    width: 100%;
    height: auto;
    display: block;
    filter: brightness(1);
  }

  .chair-img-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 52%;
    object-fit: cover;
    z-index: 3;
  }

  .chair-img-overlay-2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 4;
  }
  
 
  
  #sizeChangeBtn {
    padding: 8px 12px;
    background-color: gold;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
    width: 110px;
    text-align: center;
	text-transform: none !important;
   
  }
  
  #sizeChangeBtn:hover {
    background-color: gold;
  }
  
  
  @media (min-width: 769px) {
    .frame-img {
      transform: translateX(-50%) translateY(85px) scale(1.15, 1.09 * 1.2);
    }
  }
  
  @media (max-width: 768px) {
    .frame-img {
      transform: translateX(-50%) translateY(70px) scale(1.15, 1.09 * 1.2);
	  filter: drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.4));
    }
  }
  
   @media (min-width: 769px) {
    .urun-image {
      transform: translateY(85px);
    }
  }
  
  @media (max-width: 768px) {
    .urun-image {
      transform: translateY(70px);
	  filter: drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.4));
    
    }
  }

  @media (max-width: 768px) {
    .popup-content {
      width: 90vw;
      max-height: 90vh;
      overflow-y: auto;
      top: 50% !important;
      transform: translate(-50%, -50%) scale(1) !important;
      margin-top: 0 !important;
    }
    
    .close-btn {
      position: absolute;
      top: -7px;
      right: 12px;
      font-size: 40px;
      cursor: pointer;
      z-index: 121;
      transition: transform 0.25s ease;
	  margin-top: -10px;

    }
    
    .controls-container {
      left:-15px;
      flex-direction: row;
      gap: 0px;
      align-items: flex-start;
      z-index: 12;
    }
    
    .color-pickers {
      width: auto;
      align-items: center;
      margin-left: 0;
      flex-direction: row;
      gap: 10px;
      margin-top: -15px;
      z-index: 121;
    }
    
    .color-picker {
      flex-direction: row;
      align-items: flex-start;
    }
    
    .color-picker label {
      margin-right: 8px;
      white-space: nowrap;
      margin-bottom: 5px;
      font-size: 14px;
    }
    
   .frame-buttons-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 70px;
    z-index: 11;
    margin-top: -52px;
	margin-left:16px;
  }

  .frame-buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
    width: 100%;
    margin: 0 auto;
  }
  
  .frame-btn {
    flex: 0 0 auto;
    padding: 6px 8px; 
    font-size: 10px;
    height: 35px !important;
    width: 85px;
    margin-bottom: 4px;
  }
  
  .frame-btn:nth-child(1),
  .frame-btn:nth-child(2),
  .frame-btn:nth-child(3) {
    order: 1;
  }
  
  .frame-btn:nth-child(4) {
    order: 2;
	  margin-top: -2px;
    margin-right: auto;
  }
  
  #sizeChangeBtn {
    order: 2;
    margin-top: -2px;
	  padding: 6px 8px;
    font-size: 10px;
    width: 85px;
	  text-transform: none !important;
	  margin-left: auto;
  }


  }

`;

  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
})();

 function preloadImages() {
    const imageUrls = [
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/new5_revize.png?v=1744222776",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/new6_revize.png?v=1744222776",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/koltuk5_revize.svg?v=1744204964",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/koltuk3_revize.png?v=1744204964",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/koltuk4_revize.png?v=1744222620",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/birinci_revize.svg?v=1744222340",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/ikinci_revize.svg?v=1744222340",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira8_revize.svg?v=1744222340",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira4_revize.svg?v=1744222340",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira2_revize.svg?v=1744222340",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira1_revize.svg?v=1744222340",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira5_revize.svg?v=1744222340",
      "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira7_revize.svg?v=1744222340"
    ];

    imageUrls.forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }

  preloadImages();

  


  
  let currentState = {
    wallColor: '#BABABA',
    chairColor: '#8000FF',
    frameType: 'default',
    wallPattern: 0,
    currentSizeIndex: 4 // 5. boyut (mevcut boyut) ile başla
  };
  
  // Görsel boyutlandırma ölçekleri (1=küçük, 7=büyük)

const templateSuffix = window.templateSuffix || '';
let sizeScales;

if (templateSuffix === 'ledli-yatay') {
     sizeScales = [
    0.6561, // 1. boyut: %10 küçülmüş 2. boyutun hali
    0.729,  // 2. boyut: %10 küçülmüş 3. boyutun hali
    0.81,   // 3. boyut: %10 küçülmüş 4. boyutun hali
    0.9,    // 4. boyut: %10 küçülmüş mevcut boyut
    1,      // 5. boyut: mevcut boyut (normal)
    1.1,    // 6. boyut: %10 büyümüş mevcut boyut
    1.21    // 7. boyut: %10 büyümüş 6. boyutun hali
  ];
} else if (templateSuffix === 'ledli-panorama') {
     sizeScales = [
    0.6861, // 1. boyut: %10 küçülmüş 2. boyutun hali
    0.769,  // 2. boyut: %10 küçülmüş 3. boyutun hali
    0.83,   // 3. boyut: %10 küçülmüş 4. boyutun hali
    0.9,    // 4. boyut: %10 küçülmüş mevcut boyut
    0.97,      // 5. boyut: mevcut boyut (normal)
    1.07,    // 6. boyut: %10 büyümüş mevcut boyut
    1.17    // 7. boyut: %10 büyümüş 6. boyutun hali
  ];

} else {
   sizeScales = [
    0.6561, // 1. boyut: %10 küçülmüş 2. boyutun hali
    0.729,  // 2. boyut: %10 küçülmüş 3. boyutun hali
    0.81,   // 3. boyut: %10 küçülmüş 4. boyutun hali
    0.9,    // 4. boyut: %10 küçülmüş mevcut boyut
    1,      // 5. boyut: mevcut boyut (normal)
    1.1,    // 6. boyut: %10 büyümüş mevcut boyut
    1.21    // 7. boyut: %10 büyümüş 6. boyutun hali
  ];
}
  
/*
    const sizeScales = [
    0.6561, // 1. boyut: %10 küçülmüş 2. boyutun hali
    0.729,  // 2. boyut: %10 küçülmüş 3. boyutun hali
    0.81,   // 3. boyut: %10 küçülmüş 4. boyutun hali
    0.9,    // 4. boyut: %10 küçülmüş mevcut boyut
    1,      // 5. boyut: mevcut boyut (normal)
    1.1,    // 6. boyut: %10 büyümüş mevcut boyut
    1.21    // 7. boyut: %10 büyümüş 6. boyutun hali
  ];

*/

  // Boyut isimlerini tanımla
 let sizeNames;

  if (templateSuffix === 'ledli-yatay') {
   sizeNames = [
    "40x60 cm",
    "50x70 cm",
    "60x90 cm",
    "70x100 cm",
    "80x120 cm",
    "100x150 cm",
    "120x180 cm"
  ];

} else if (templateSuffix === 'ledli-panorama') {
   sizeNames = [
    "30x90 cm",
    "40x120 cm",
    "45x130 cm",
    "50x140 cm",
    "55x150 cm",
    "60x160 cm",
    "70x180 cm"
  ];

 } else {
   sizeNames = [
    "40x80 cm",
    "50x100 cm",
    "60x120 cm",
    "70x140 cm",
    "80x160 cm",
    "90x180 cm",
    "100x200 cm"
  ];

  } 


  // Ürün varyantlarından seçili boyutu alır
  function getSelectedVariantSize() {
    const variantSelector = document.querySelector('.product-form__input:nth-of-type(2)');
    
    // Eğer varyant seçici bulunamazsa, varsayılan değeri döndür
    if (!variantSelector) return 4; // Default: 80x120 cm
    
    // Varyant seçici içinde aktif olan/seçilmiş olan radyo butonunu bul
    const selectedRadio = variantSelector.querySelector('input[type="radio"]:checked');
    if (!selectedRadio) return 4; // Default: 80x120 cm
    
    // Seçilen radyo butonunun etiketini bul
    const selectedLabel = selectedRadio.nextElementSibling || 
                          variantSelector.querySelector(`label[for="${selectedRadio.id}"]`);
    
    if (!selectedLabel) return 4; // Default: 80x120 cm
    
    // Etiket içindeki metni al
    const labelText = selectedLabel.textContent.trim();
    
    // sizeNames dizisinde bu değerin bulunduğu indeksi bul
    for (let i = 0; i < sizeNames.length; i++) {
      // Eğer varyant etiketi, boyut ismini içeriyorsa indeksi döndür
      if (labelText.includes(sizeNames[i].replace(" cm", "")) || 
          labelText.includes(sizeNames[i])) {
        return i;
      }
    }
    
    // Eşleşme bulunamadıysa varsayılan değeri döndür
    return 4; // Default: 80x120 cm
  }

  function adjustPopupScale() {
    if (window.innerWidth <= 768) return;

    const popupContent = document.querySelector('.popup-content');
    if (!popupContent) return;

    const textElements = popupContent.querySelectorAll('button, label, span, p, h1, h2, h3, h4, h5, h6');
    textElements.forEach(el => {
      el.style.opacity = '0';
      el.style.willChange = 'opacity, transform';
    });

    const originalWidth = 600;
    const maxWidth = window.innerWidth * 0.9;
    const maxHeight = window.innerHeight * 0.9;
    
    let scale = 1.5;
    if (originalWidth * scale > maxWidth || popupContent.offsetHeight * scale > maxHeight) {
      scale = Math.min(maxWidth / originalWidth, maxHeight / popupContent.offsetHeight);
    }

    requestAnimationFrame(() => {
      popupContent.style.transform = `translate(-50%, -50%) scale(${scale})`;
      
      textElements.forEach((el, index) => {
        requestAnimationFrame(() => {
          Promise.resolve().then(() => {
            el.style.opacity = '1';
            void el.offsetHeight; 
          });
        }); 
      });
    });
  }
  
  // Ürün ve çerçeve boyutunu değiştir
  function changeProductSize() {
    currentState.currentSizeIndex = (currentState.currentSizeIndex + 1) % sizeScales.length;
    const scale = sizeScales[currentState.currentSizeIndex];
    
    // Ürün görselini boyutlandır
    const productImage = document.querySelector('.urun-image');
    if (productImage) {
      if (window.innerWidth > 768) {

         if (templateSuffix === 'ledli-yatay') {
        productImage.style.transform = `translateY(85px) scale(${scale})`;

        } else if (templateSuffix === 'ledli-panorama') {
        productImage.style.transform = `translateY(85px) scale(${scale * 1.2}, ${scale * 1.4})`;

       } else {
        productImage.style.transform = `translateY(85px) scale(${scale * 1.2}, ${scale})`;

         }
      } else {

         if (templateSuffix === 'ledli-yatay') {
        productImage.style.transform = `translateY(70px) scale(${scale})`;

        } else if (templateSuffix === 'ledli-panorama') {
        productImage.style.transform = `translateY(70px) scale(${scale * 1.2}, ${scale * 1.4})`;

         } else {
        productImage.style.transform = `translateY(70px) scale(${scale * 1.2}, ${scale})`;

       }

      }
    }
    
    // Çerçeve görsellerini boyutlandır
    const blackFrame = document.getElementById('blackFrame');
    const whiteFrame = document.getElementById('whiteFrame');
    if (blackFrame) {
      if (window.innerWidth > 768) {

       if (templateSuffix === 'ledli-yatay') {
         blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

        }
      
      } else {

        if (templateSuffix === 'ledli-yatay') {
         blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

         } else if (templateSuffix === 'ledli-panorama') {
          blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

       } 

      }
    }
    if (whiteFrame) {
      if (window.innerWidth > 768) {

         if (templateSuffix === 'ledli-yatay') {
         whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

         } else {
         whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

         } 

      } else {

        if (templateSuffix === 'ledli-yatay') {
         whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

         } else {
         whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

       } 
      }
    }
    
    // Buton metnini güncelle
    const sizeBtn = document.getElementById('sizeChangeBtn');
    if (sizeBtn) {
      sizeBtn.textContent = sizeNames[currentState.currentSizeIndex];
    }
  }

  function initPopupFunctions() {
    document.getElementById('closePopup').onclick = function() {
      document.getElementById('popup').style.display = 'none';
    };

    window.onclick = function(event) {
      if (event.target === document.getElementById('popup')) {
        document.getElementById('popup').style.display = 'none';
      }
    };

    document.getElementById('popupColorPicker').addEventListener('input', function(e) {
      currentState.wallColor = e.target.value;
      document.querySelector('.popup-content').style.backgroundColor = e.target.value;
    });

    document.getElementById('chairColorPicker').addEventListener('input', function(e) {
      const color = e.target.value;
      currentState.chairColor = color;
      updateChairColor(color);
    });
    
    // Boyut değiştirme butonu
    document.getElementById('sizeChangeBtn').addEventListener('click', function() {
      changeProductSize();
      this.blur();
    });

    function updateChairColor(hexColor) {
      const img = document.getElementById('koltukImage');
      if (!img) return;
      
      const filterId = 'chairColorFilter';
      if (!document.getElementById(filterId)) {
        const svgNS = "http://www.w3.org/2000/svg";
        const svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("width", "0");
        svg.setAttribute("height", "0");
        svg.style.position = "absolute";
        svg.style.visibility = "hidden";
        
        const filter = document.createElementNS(svgNS, "filter");
        filter.setAttribute("id", filterId);
        filter.setAttribute("color-interpolation-filters", "sRGB");
        
        const feColorMatrix = document.createElementNS(svgNS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        
        filter.appendChild(feColorMatrix);
        svg.appendChild(filter);
        document.body.appendChild(svg);
      }
      
      const r = parseInt(hexColor.substr(1, 2), 16) / 255;
      const g = parseInt(hexColor.substr(3, 2), 16) / 255;
      const b = parseInt(hexColor.substr(5, 2), 16) / 255;
      
      const feColorMatrix = document.querySelector(`#${filterId} feColorMatrix`);
      feColorMatrix.setAttribute("values", `0 0 0 0 ${r} 0 0 0 0 ${g} 0 0 0 0 ${b} 0 0 0 1 0`);
      
      img.style.filter = `url('#${filterId}')`;
      
      if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        const iOSFilter = `<svg xmlns="http://www.w3.org/2000/svg" style="position:absolute;width:0;height:0">
          <filter id="iOSChairFilter">
            <feColorMatrix type="matrix" values="0 0 0 0 ${r} 0 0 0 0 ${g} 0 0 0 0 ${b} 0 0 0 1 0"/>
          </filter>
        </svg>`;
        
        if (!document.getElementById('iOSChairFilter')) {
          document.body.insertAdjacentHTML('beforeend', iOSFilter);
        } else {
          const feMatrix = document.querySelector('#iOSChairFilter feColorMatrix');
          feMatrix.setAttribute("values", `0 0 0 0 ${r} 0 0 0 0 ${g} 0 0 0 0 ${b} 0 0 0 1 0`);
        }
        
        img.style.webkitFilter = `url('#iOSChairFilter')`;
        
        // Additional fallback using CSS variables for coloring
        document.documentElement.style.setProperty('--chair-color-r', r);
        document.documentElement.style.setProperty('--chair-color-g', g);
        document.documentElement.style.setProperty('--chair-color-b', b);
        img.style.opacity = '0.9999'; // Force repaint in iOS
        setTimeout(() => { img.style.opacity = '1'; }, 10);
      }
    }
   
    document.getElementById('blackFrameBtn').addEventListener('click', function() {
      document.getElementById('whiteFrame').style.display = 'none';
      document.getElementById('blackFrame').style.display = 'block';
      document.querySelector('.urun-image').style.filter = 'none';
      this.classList.add('active');
      document.getElementById('whiteFrameBtn').classList.remove('active');
      document.getElementById('defaultFrameBtn').classList.remove('active');
      currentState.frameType = 'black';
      
      // Mevcut boyutu uygula
      const scale = sizeScales[currentState.currentSizeIndex];
      if (window.innerWidth > 768) {

         if (templateSuffix === 'ledli-yatay') {
        document.getElementById('blackFrame').style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

       } else if (templateSuffix === 'ledli-panorama') {
        document.getElementById('blackFrame').style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
        document.getElementById('blackFrame').style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

        } 

      } else {


        if (templateSuffix === 'ledli-yatay') {
         document.getElementById('blackFrame').style.transform = `translateX(-50%) translateY(70px) rotate(90deg)  scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
         document.getElementById('blackFrame').style.transform = `translateX(-50%) translateY(70px) rotate(90deg)  scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

         } else {
         document.getElementById('blackFrame').style.transform = `translateX(-50%) translateY(70px) rotate(90deg)  scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

       }

      }
    });

    document.getElementById('whiteFrameBtn').addEventListener('click', function() {
      document.getElementById('blackFrame').style.display = 'none';
      document.getElementById('whiteFrame').style.display = 'block';
      document.querySelector('.urun-image').style.filter = 'none';
      this.classList.add('active');
      document.getElementById('blackFrameBtn').classList.remove('active');
      document.getElementById('defaultFrameBtn').classList.remove('active');
      currentState.frameType = 'white';
      
      // Mevcut boyutu uygula
      const scale = sizeScales[currentState.currentSizeIndex];
      if (window.innerWidth > 768) {

         if (templateSuffix === 'ledli-yatay') {
        document.getElementById('whiteFrame').style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

         } else if (templateSuffix === 'ledli-panorama') {
        document.getElementById('whiteFrame').style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

         } else {
        document.getElementById('whiteFrame').style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

       }

      } else {

        if (templateSuffix === 'ledli-yatay') {
         document.getElementById('whiteFrame').style.transform = `translateX(-50%) translateY(70px) rotate(90deg)  scale(${scale  * 1.15}, ${scale * 1.11})`;

         } else if (templateSuffix === 'ledli-panorama') {
         document.getElementById('whiteFrame').style.transform = `translateX(-50%) translateY(70px) rotate(90deg)  scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

         } else {
         document.getElementById('whiteFrame').style.transform = `translateX(-50%) translateY(70px) rotate(90deg)  scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

        }

      }
    });

    document.getElementById('defaultFrameBtn').addEventListener('click', function() {
      document.getElementById('blackFrame').style.display = 'none';
      document.getElementById('whiteFrame').style.display = 'none';
	  
	   if (window.innerWidth > 768) {
      document.querySelector('.urun-image').style.filter = 'drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.4))';
      } else {
      document.querySelector('.urun-image').style.filter = 'drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.4))';
      }
	  
      this.classList.add('active');
      document.getElementById('blackFrameBtn').classList.remove('active');
      document.getElementById('whiteFrameBtn').classList.remove('active');
      currentState.frameType = 'default';
    });
    
    const wallPatterns = [
      null,
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/birinci_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/ikinci_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira8_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira4_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira2_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira1_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira5_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira7_revize.svg?v=1744222340'
    ];

    document.getElementById('removeWallBtn').addEventListener('click', function() {
      const popupContent = document.querySelector('.popup-content');
      const currentColor = document.getElementById('popupColorPicker').value;
      
      currentState.wallPattern = (currentState.wallPattern + 1) % wallPatterns.length;
      
      if (currentState.wallPattern === 0) {
        popupContent.style.background = currentColor;
        popupContent.style.backgroundImage = 'none';
        this.textContent = 'Duvar Modeli 1';
      } else if (currentState.wallPattern === wallPatterns.length - 1) {
        popupContent.style.background = `url('${wallPatterns[currentState.wallPattern]}'), ${currentColor}`;
        popupContent.style.backgroundSize = 'cover';
        popupContent.style.backgroundPosition = 'center';
        this.textContent = 'Orijinal Duvar';
      } else {
        popupContent.style.background = `url('${wallPatterns[currentState.wallPattern]}'), ${currentColor}`;
        popupContent.style.backgroundSize = 'cover';
        popupContent.style.backgroundPosition = 'center';
        this.textContent = `Duvar Modeli ${currentState.wallPattern + 1}`;
      }
      
      this.blur();
    });
    
    updateChairColor('#8000FF');
    document.getElementById('chairColorPicker').value = '#8000FF';
    currentState.chairColor = '#8000FF';
    document.getElementById('defaultFrameBtn').classList.add('active');
    document.getElementById('sizeChangeBtn').textContent = sizeNames[currentState.currentSizeIndex];
  }
  
  function restoreState() {
    if (!document.getElementById('popup') || document.getElementById('popup').style.display === 'none') return;
    
    document.querySelector('.popup-content').style.backgroundColor = currentState.wallColor;
    document.getElementById('popupColorPicker').value = currentState.wallColor;
    
    document.getElementById('chairColorPicker').value = currentState.chairColor;
    updateChairColor(currentState.chairColor);
    
    document.getElementById('blackFrame').style.display = 'none';
    document.getElementById('whiteFrame').style.display = 'none';
	
	if (window.innerWidth > 768) {
    document.querySelector('.urun-image').style.filter = 'drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.4))';

      } else {
          document.querySelector('.urun-image').style.filter = 'drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.4))';
	  }
    
    document.getElementById('blackFrameBtn').classList.remove('active');
    document.getElementById('whiteFrameBtn').classList.remove('active');
    document.getElementById('defaultFrameBtn').classList.remove('active');
    
    if (currentState.frameType === 'black') {
      document.getElementById('blackFrame').style.display = 'block';
      document.querySelector('.urun-image').style.filter = 'none';
      document.getElementById('blackFrameBtn').classList.add('active');
    } else if (currentState.frameType === 'white') {
      document.getElementById('whiteFrame').style.display = 'block';
      document.querySelector('.urun-image').style.filter = 'none';
      document.getElementById('whiteFrameBtn').classList.add('active');
    } else {
      document.getElementById('defaultFrameBtn').classList.add('active');
    }
    
    const wallPatterns = [
      null,
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/birinci_revize.svg?v=1744222340',	
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/ikinci_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira8_revize.svg?v=1744222340',
	  'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira4_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira2_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira1_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira5_revize.svg?v=1744222340',
      'https://cdn.shopify.com/s/files/1/0904/5717/8475/files/sira7_revize.svg?v=1744222340'
    ];
    
    const popupContent = document.querySelector('.popup-content');
    const btn = document.getElementById('removeWallBtn');
    
    if (currentState.wallPattern === 0) {
      popupContent.style.background = currentState.wallColor;
      popupContent.style.backgroundImage = 'none';
      if (btn) btn.textContent = 'Duvar Modeli 1';
    } else {
      popupContent.style.background = `url('${wallPatterns[currentState.wallPattern]}'), ${currentState.wallColor}`;
      popupContent.style.backgroundSize = 'cover';
      popupContent.style.backgroundPosition = 'center';
      if (btn) {
        btn.textContent = currentState.wallPattern === wallPatterns.length - 1 ? 
          'Orijinal Duvar' : `Duvar Modeli ${currentState.wallPattern + 1}`;
      }
    }
    
    // Boyut ayarını geri yükle
    const scale = sizeScales[currentState.currentSizeIndex];
    const productImage = document.querySelector('.urun-image');
    if (productImage) {
    
       if (window.innerWidth > 768) {

      if (templateSuffix === 'ledli-yatay') {
        productImage.style.transform = `translateY(85px) scale(${scale})`;

       } else if (templateSuffix === 'ledli-panorama') {
        productImage.style.transform = `translateY(85px) scale(${scale * 1.2}, ${scale * 1.4})`;

       } else {
        productImage.style.transform = `translateY(85px) scale(${scale * 1.2}, ${scale})`;

        }
      } else {

        if (templateSuffix === 'ledli-yatay') {
        productImage.style.transform = `translateY(70px) scale(${scale})`;

       } else if (templateSuffix === 'ledli-panorama') {
        productImage.style.transform = `translateY(70px) scale(${scale * 1.2}, ${scale * 1.4})`;

         } else {
        productImage.style.transform = `translateY(70px) scale(${scale * 1.2}, ${scale})`;

       } 

      }
    }

    // Çerçeveleri boyutlandır
    const blackFrame = document.getElementById('blackFrame');
    const whiteFrame = document.getElementById('whiteFrame');
    if (blackFrame && currentState.frameType === 'black') {
        if (window.innerWidth > 768) {

        if (templateSuffix === 'ledli-yatay') {
         blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

        }

      } else {

        if (templateSuffix === 'ledli-yatay') {
         blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

         } else if (templateSuffix === 'ledli-panorama') {
          blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

         } else {
         blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

        } 
      }
    }
    if (whiteFrame && currentState.frameType === 'white') {
      if (window.innerWidth > 768) {


         if (templateSuffix === 'ledli-yatay') {
         whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

         } else if (templateSuffix === 'ledli-panorama') {
          whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

         }

      } else {


        if (templateSuffix === 'ledli-yatay') {
         whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

       } else {
         whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

       }
      }
    }
    
    // Boyut butonunun metnini güncelle
    const sizeBtn = document.getElementById('sizeChangeBtn');
    if (sizeBtn) {
      sizeBtn.textContent = sizeNames[currentState.currentSizeIndex];
    }
  }
  
  function getSelectedFrameIndex() {
  const variantSelector = document.querySelector('.product-form__input:nth-of-type(1)');
  if (!variantSelector) return 0;

  const selectedRadio = variantSelector.querySelector('input[type="radio"]:checked');
  if (!selectedRadio) return 0;

  const radios = [...variantSelector.querySelectorAll('input[type="radio"]')];
  return radios.findIndex(r => r === selectedRadio);
}

function applyFrameSelectionFromVariant() {
  const index = getSelectedFrameIndex();
  const blackBtn = document.getElementById('blackFrameBtn');
  const whiteBtn = document.getElementById('whiteFrameBtn');
  const defaultBtn = document.getElementById('defaultFrameBtn');

  if (index === 0) {
    defaultBtn.click();
  } else if (index === 1) {
    blackBtn.click();
  } else if (index === 2) {
    whiteBtn.click();
  }
  else {
    defaultBtn.click();
  }
}

  function updateChairColor(hexColor) {
    const img = document.getElementById('koltukImage');
    if (!img) return;
    
	
	const chairContainer = document.querySelector('.chair-container');
  const originalShadow = chairContainer ? chairContainer.style.filter : '';
  
  // iOS cihazlarda shadow filtresini geçici olarak kaldır
  if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && chairContainer) {
    chairContainer.style.filter = 'none';
  }
	
    const filterId = 'chairColorFilter';
    if (!document.getElementById(filterId)) {
      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("id", filterId);
      svg.setAttribute("width", "0");
      svg.setAttribute("height", "0");
      svg.style.position = "absolute";
      svg.style.visibility = "hidden";
      
      const filter = document.createElementNS(svgNS, "filter");
      filter.setAttribute("id", "chairFilter");
      filter.setAttribute("color-interpolation-filters", "sRGB");
      
      const feColorMatrix = document.createElementNS(svgNS, "feColorMatrix");
      feColorMatrix.setAttribute("type", "matrix");
      
      filter.appendChild(feColorMatrix);
      svg.appendChild(filter);
      document.body.appendChild(svg);
    }
    
    const r = parseInt(hexColor.substr(1, 2), 16) / 255;
    const g = parseInt(hexColor.substr(3, 2), 16) / 255;
    const b = parseInt(hexColor.substr(5, 2), 16) / 255;
    
    const feColorMatrix = document.querySelector(`#chairFilter feColorMatrix`);
    feColorMatrix.setAttribute("values", `0 0 0 0 ${r} 0 0 0 0 ${g} 0 0 0 0 ${b} 0 0 0 1 0`);
    
    img.style.filter = `url('#chairFilter')`;
    
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      const iOSFilterHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" style="position:absolute;width:0;height:0">
          <filter id="iOSChairFilter">
            <feColorMatrix type="matrix" values="0 0 0 0 ${r} 0 0 0 0 ${g} 0 0 0 0 ${b} 0 0 0 1 0"/>
          </filter>
        </svg>
      `;
      
      if (!document.getElementById('iOSSVGFilter')) {
        const div = document.createElement('div');
        div.id = 'iOSSVGFilter';
        div.innerHTML = iOSFilterHTML;
        document.body.appendChild(div);
      } else {
        const matrix = document.querySelector('#iOSChairFilter feColorMatrix');
        if (matrix) {
          matrix.setAttribute("values", `0 0 0 0 ${r} 0 0 0 0 ${g} 0 0 0 0 ${b} 0 0 0 1 0`);
        }
      }
      
      img.style.webkitFilter = `url('#iOSChairFilter')`;
      
      img.style.opacity = '0.9999';
      setTimeout(() => {
        img.style.opacity = '1';
        
        const styleEl = document.getElementById('iosColorStyle') || document.createElement('style');
        if (!document.getElementById('iosColorStyle')) {
          styleEl.id = 'iosColorStyle';
          document.head.appendChild(styleEl);
        }
        
        styleEl.textContent = `
          #koltukImage { 
            -webkit-filter: brightness(0) saturate(100%) !important;
            filter: brightness(0) saturate(100%) !important;
            background-color: ${hexColor} !important;
            mix-blend-mode: screen !important;
          }
        `;
      }, 10);
    }
	
	if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && chairContainer) {
    setTimeout(() => {
      chairContainer.style.filter = originalShadow || 'drop-shadow(2px 1px 2px rgba(0, 0, 0, 0.4))';
    }, 20);
  }
	
  }

  function initPopup() {
    setTimeout(() => {
      adjustPopupScale();
      preloadImages();
      const images = document.querySelectorAll('.popup-content img');
      images.forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', adjustPopupScale);
        }
      });
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', function() {

    const mountTarget = document.querySelector('.product__block--custom_liquid');
    if (!mountTarget) return;
    const openBtn = document.createElement('button');
    openBtn.id = 'openPopup';
    openBtn.className = 'open-popup-btn';
    openBtn.textContent = 'Kişisel Alanınızda Keşfedin'; 
    mountTarget.appendChild(openBtn);
    openBtn.addEventListener('click', initPopup);
    
    openBtn.addEventListener('click', function () {
    setTimeout(() => {
      adjustPopupScale();

      const images = document.querySelectorAll('.popup-content img');
      let loadedImages = 0;

      images.forEach(img => {
        if (img.complete) {
          loadedImages++;
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === images.length) adjustPopupScale();
          });
        }
      });

      if (loadedImages === images.length) adjustPopupScale();
    }, 50);
  });
    
    openBtn.addEventListener('click', function () {
    setTimeout(() => {
      adjustPopupScale();

      const images = document.querySelectorAll('.popup-content img');
      let loadedImages = 0;

      images.forEach(img => {
        if (img.complete) {
          loadedImages++;
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === images.length) adjustPopupScale();
          });
        }
      });

      if (loadedImages === images.length) adjustPopupScale();
    }, 50);
  });
    
    openBtn.addEventListener('click', function() {
  
      const selectedSizeIndex = getSelectedVariantSize();
     
      if (selectedSizeIndex !== -1) {
        currentState.currentSizeIndex = selectedSizeIndex;
      }
      
      let popup = document.getElementById('popup');
      if (popup) {
        popup.style.display = 'block';
		 const sizeBtn = document.getElementById('sizeChangeBtn');
 
     if (sizeBtn) {
      sizeBtn.textContent = sizeNames[currentState.currentSizeIndex];
    }

	const scale = sizeScales[currentState.currentSizeIndex];
    const productImage = document.querySelector('.urun-image');
    if (productImage) {
     if (window.innerWidth > 768) {

        if (templateSuffix === 'ledli-yatay') {
        productImage.style.transform = `translateY(85px) scale(${scale})`;

        } else if (templateSuffix === 'ledli-panorama') {
        productImage.style.transform = `translateY(85px) scale(${scale * 1.2}, ${scale * 1.4})`;

        } else {
        productImage.style.transform = `translateY(85px) scale(${scale * 1.2}, ${scale})`;

       }
      } else {

        if (templateSuffix === 'ledli-yatay') {
        productImage.style.transform = `translateY(70px) scale(${scale})`;

        } else if (templateSuffix === 'ledli-panorama') {
        productImage.style.transform = `translateY(70px) scale(${scale * 1.2}, ${scale * 1.4})`;

        } else {
        productImage.style.transform = `translateY(70px) scale(${scale * 1.2}, ${scale})`;

      }

      }

    }
    
    // Çerçeveleri boyutlandır
    const blackFrame = document.getElementById('blackFrame');
    const whiteFrame = document.getElementById('whiteFrame');
    if (blackFrame) {
      if (window.innerWidth > 768) {

        if (templateSuffix === 'ledli-yatay') {
         blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

       }

      
      } else {


        if (templateSuffix === 'ledli-yatay') {
         blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

      }
      }
    }
    if (whiteFrame) {
     if (window.innerWidth > 768) {


        if (templateSuffix === 'ledli-yatay') {
         whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

       }

      } else {


         if (templateSuffix === 'ledli-yatay') {
         whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
          whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15 * 0.8}, ${scale * 1.09 * 1.17})`;

        } else {
         whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${scale  * 1.15}, ${scale * 1.09 * 1.2})`;

        }
      }
    }
	
        restoreState();
        setTimeout(adjustPopupScale, 50);
        return;
      }
      
      popup = document.createElement('div');
      popup.id = 'popup';
      popup.className = 'popup';
      
      const popupContent = document.createElement('div');
      popupContent.className = 'popup-content';
      popupContent.style.backgroundColor = currentState.wallColor;
      
      const closeBtn = document.createElement('span');
      closeBtn.id = 'closePopup';
      closeBtn.className = 'close-btn';
      closeBtn.innerHTML = '&times;';
      
      const controlsContainer = document.createElement('div');
      controlsContainer.className = 'controls-container';
      
      const colorPickers = document.createElement('div');
      colorPickers.className = 'color-pickers';
      
      const wallColorPicker = document.createElement('div');
      wallColorPicker.className = 'color-picker';
      wallColorPicker.innerHTML = `
        <label for="popupColorPicker">Duvar:</label>
        <input type="color" id="popupColorPicker" value="${currentState.wallColor}">
      `;
      
      const chairColorPicker = document.createElement('div');
      chairColorPicker.className = 'color-picker';
      chairColorPicker.innerHTML = `
        <label for="chairColorPicker">Koltuk:</label>
        <input type="color" id="chairColorPicker" value="${currentState.chairColor}">
      `;
      
      colorPickers.appendChild(wallColorPicker);
      colorPickers.appendChild(chairColorPicker);
      
      const frameButtonsWrapper = document.createElement('div');
      frameButtonsWrapper.className = 'frame-buttons-wrapper';
      
      const frameButtons = document.createElement('div');
      frameButtons.className = 'frame-buttons';
      frameButtons.innerHTML = `
  <button id="blackFrameBtn" class="frame-btn">Siyah Çerçeve</button>
  <button id="whiteFrameBtn" class="frame-btn">Beyaz Çerçeve</button>
  <button id="defaultFrameBtn" class="frame-btn">Standart</button>
  <button id="removeWallBtn" class="frame-btn">${currentState.wallPattern === 0 ? 'Duvar Modeli 1' : 
    currentState.wallPattern === 8 ? 'Orijinal Duvar' : `Duvar Modeli ${currentState.wallPattern + 1}`}</button>
  <button id="sizeChangeBtn" class="frame-btn">${sizeNames[currentState.currentSizeIndex]}</button>
`;
      
      frameButtonsWrapper.appendChild(frameButtons);
      controlsContainer.appendChild(colorPickers);
      controlsContainer.appendChild(frameButtonsWrapper);
      
      const frameContainer = document.createElement('div');
      frameContainer.className = 'frame-container';
      


 
 // Tüm media item'ları seç
      
    
   const mediaItems = [...document.querySelectorAll(".product__media-item")];

    // Sadece görsel tipinde olanlardan en büyük indexli olanı seç
    const lastImage = mediaItems
      .filter(item => item.getAttribute("data-media-type") === "image")
      .reduce((max, item) => {
        const idx = parseInt(item.getAttribute("data-media-index"), 10);
        return !isNaN(idx) && idx > (parseInt(max?.getAttribute("data-media-index") || "-1", 10)) ? item : max;
      }, null);

    if (lastImage) {
      const imgSrc = lastImage.getAttribute("data-src") || lastImage.querySelector("img")?.src;
      if (imgSrc) {
        const productImage = document.createElement("img");
        productImage.src = imgSrc.startsWith("http") ? imgSrc : "https:" + imgSrc;
        productImage.alt = "Son ürün görseli";
        productImage.className = "urun-image";

         if (window.innerWidth > 768) {


            if (templateSuffix === 'ledli-yatay') {
            productImage.style.transform = `translateY(85px) scale(${sizeScales[currentState.currentSizeIndex] }, ${sizeScales[currentState.currentSizeIndex]})`;

            } else if (templateSuffix === 'ledli-panorama') {
            productImage.style.transform = `translateY(85px) scale(${sizeScales[currentState.currentSizeIndex] * 1.2}, ${sizeScales[currentState.currentSizeIndex] * 1.4})`;

            } else {
            productImage.style.transform = `translateY(85px) scale(${sizeScales[currentState.currentSizeIndex] * 1.2}, ${sizeScales[currentState.currentSizeIndex]})`;

            }


            } else {

            if (templateSuffix === 'ledli-yatay') {
            productImage.style.transform = `translateY(70px) scale(${sizeScales[currentState.currentSizeIndex] }, ${sizeScales[currentState.currentSizeIndex]})`;

            } else if (templateSuffix === 'ledli-panorama') {
            productImage.style.transform = `translateY(70px) scale(${sizeScales[currentState.currentSizeIndex] * 1.2}, ${sizeScales[currentState.currentSizeIndex] * 1.4})`;

            } else {
            productImage.style.transform = `translateY(70px) scale(${sizeScales[currentState.currentSizeIndex] * 1.2}, ${sizeScales[currentState.currentSizeIndex]})`;

            }


        }

        frameContainer.appendChild(productImage);
      }
    }
 

     
      





      const blackFrame = document.createElement('img');
      blackFrame.id = 'blackFrame';
      blackFrame.src = "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/new5_revize.png?v=1744222776";
      blackFrame.alt = "Siyah Çerçeve";
      blackFrame.className = "frame-img black-frame";
      if (window.innerWidth > 768) {



       if (templateSuffix === 'ledli-yatay') {
       blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
       blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15 * 0.9}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

        } else {
        blackFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

        }



      } else {

      if (templateSuffix === 'ledli-yatay') {
       blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
       blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15 * 0.9}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

        } else {
        blackFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

        }

      }
      frameContainer.appendChild(blackFrame);
      
      const whiteFrame = document.createElement('img');
      whiteFrame.id = 'whiteFrame';
      whiteFrame.src = "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/new6_revize.png?v=1744222776";
      whiteFrame.alt = "Beyaz Çerçeve";
      whiteFrame.className = "frame-img white-frame";


       if (window.innerWidth > 768) {

       if (templateSuffix === 'ledli-yatay') {
       whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
       whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15 * 0.9}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

        } else {
        whiteFrame.style.transform = `translateX(-50%) translateY(85px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

        }



      } else {

      if (templateSuffix === 'ledli-yatay') {
       whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.11})`;

        } else if (templateSuffix === 'ledli-panorama') {
       whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15 * 0.9}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

        } else {
        whiteFrame.style.transform = `translateX(-50%) translateY(70px) rotate(90deg) scale(${sizeScales[currentState.currentSizeIndex]  * 1.15}, ${sizeScales[currentState.currentSizeIndex] * 1.09 * 1.2})`;

      }

      }

      frameContainer.appendChild(whiteFrame);
      
      const chairContainer = document.createElement('div');
      chairContainer.className = 'chair-container';
      
      const chairImg = document.createElement('img');
      chairImg.id = 'koltukImage';
      chairImg.src = "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/koltuk5_revize.svg?v=1744204964";
      chairImg.alt = "Koltuk";
      chairImg.className = "chair-img";
      
      const chairImgOverlay = document.createElement('img');
      chairImgOverlay.id = 'koltukImageOverlay';
      chairImgOverlay.src = "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/koltuk3_revize.png?v=1744204964";
      chairImgOverlay.alt = "Koltuk Overlay";
      chairImgOverlay.className = "chair-img-overlay";
      
      const chairImgOverlay2 = document.createElement('img');
      chairImgOverlay2.id = 'koltukImageOverlay2';
      chairImgOverlay2.src = "https://cdn.shopify.com/s/files/1/0904/5717/8475/files/koltuk4_revize.png?v=1744222620";
      chairImgOverlay2.alt = "Koltuk Overlay 2";
      chairImgOverlay2.className = "chair-img-overlay-2";
      
      chairContainer.appendChild(chairImg);
      chairContainer.appendChild(chairImgOverlay);
      chairContainer.appendChild(chairImgOverlay2);
      
      popupContent.appendChild(closeBtn);
      popupContent.appendChild(controlsContainer);
      popupContent.appendChild(frameContainer);
      popupContent.appendChild(chairContainer);
      popup.appendChild(popupContent);
      
      document.body.appendChild(popup);
      popup.style.display = 'block';
      initPopupFunctions();
      restoreState();
    });

    
document.getElementById('openPopup').addEventListener('click', function () {
  setTimeout(applyFrameSelectionFromVariant, 100);
});

document.querySelectorAll('.product-form__input:nth-of-type(1) input[type="radio"]').forEach(radio => {
  radio.addEventListener('change', applyFrameSelectionFromVariant);
});

    
  });

  window.addEventListener('resize', adjustPopupScale);